import React, { useEffect } from "react";
import { Form, Row, Col } from "antd";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import ControlledDatePicker from "../../components/Backoffice/ControlledDatePicker";
import ControlledRadio from "../../components/Backoffice/ControlledRadio";
import ControlledTextArea from "../../components/ControlledTextArea";
import ControlledSelect from "../../components/Backoffice/ControlledSelectV1";
import { ImageUpload } from "../../components/Backoffice/ImageUpload";

const AddLabLabellingForm = ({ options, control, watch, errors, setValue }) => {
  const disableFields = options.disableFields;
  const disabledFormFields = options.disabledFormFields;
  const sampleVariant = options.sampleVariant;
  const currentDate = new Date();
  //   const additionalSampleNeeded = watch("additionalSampleNeeded");
  const brandNamePresent = watch("brandNamePresent");
  const frontImage = watch("frontImage");
  const backImage = watch("backImage");
  const manufacturingAddressPresent = watch("manufacturingAddressPresent");
  const manufacturingAddress = watch("manufacturingAddress");
  const manufacturingDatePresent = watch("manufacturingDatePresent");
  const manufacturingDate = watch("manufacturingDate");
  const expireByDatePresent = watch("expireByDatePresent");
  const jaivikKisanLogoPresent = watch("jaivikKisanLogoPresent");
  const fssaiLogoPresent = watch("fssaiLogoPresent");
  const fssaiLicenseNumberPresent = watch("fssaiLicenseNumberPresent");
  const countryOfOriginPresent = watch("countryOfOriginPresent");
  const vegSymbolPresent = watch("vegSymbolPresent");
  const lotNumber = watch("lotNumber");
  const lotNumberPresent = watch("lotNumberPresent");

  useEffect(() => {
    if (countryOfOriginPresent === "No") setValue("countryOfOrigin", "");
    if (brandNamePresent === "No") setValue("brandName", "");
    if (manufacturingAddressPresent === "No")
      setValue("manufacturingAddress", "");
    if (manufacturingAddressPresent === "No")
      setValue("manufacturingAddress", "");
    if (expireByDatePresent === "No") setValue("expireByDate", "");
    if (manufacturingDatePresent === "No") setValue("manufacturingDate", "");
    if (vegSymbolPresent === "No") setValue("vegOrNonVeg", "");
    if (fssaiLicenseNumberPresent === "No") setValue("fssaiLicenseNumber", "");
    if (lotNumberPresent === "No") setValue("lotNumber", "");
  }, [
    countryOfOriginPresent,
    brandNamePresent,
    vegSymbolPresent,
    fssaiLicenseNumberPresent,
    manufacturingAddressPresent,
    expireByDatePresent,
    manufacturingDatePresent,
    lotNumberPresent,
  ]);

  return (
    <Form colon={false} layout="vertical">
      <Row gutter={24} style={{ marginTop: "8px" }}>
        <Col span={12}>
          <ImageUpload
            control={control}
            name="frontImage"
            label="Upload Front Image of Pack"
            errors={errors}
            required={true}
            acceptType={["image/*"]}
            maxCount={1}
            disabled={disabledFormFields}
          />
        </Col>

        <Col span={12}>
          <ImageUpload
            control={control}
            name="backImage"
            label="Upload Back Image of Pack"
            errors={errors}
            required={true}
            acceptType={["image/*"]}
            maxCount={1}
            disabled={disabledFormFields}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        {!disableFields.fssaiLogoPresent && (
          <Col span={12}>
            <ControlledRadio
              required
              control={control}
              name="fssaiLogoPresent"
              label="Is FSSAI Logo available on the pack?"
              disabled={options.disableFields.fssaiLogoPresent || disabledFormFields}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
              errors={errors}
              fullLabelWidth={true}
            />
          </Col>
        )}
      </Row>
      {!disableFields.fssaiLicenseNumberPresent && (
        <Row  gutter={24}>
          <Col span={12}>
            <ControlledRadio
              required
              control={control}
              name="fssaiLicenseNumberPresent"
              label="Is FSSAI License Number present?"
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
              errors={errors}
              fullLabelWidth={true}
              disabled={disabledFormFields}
            />
          </Col>

          {fssaiLicenseNumberPresent === "Yes" && (
            <Col span={12}>
              <ControlledInput
                required
                control={control}
                name="fssaiLicenseNumber"
                label="Provide FSSAI License number"
                errors={errors}
                fullLabelWidth={true}
                disabled={disabledFormFields}
              />
            </Col>
          )}
        </Row>
      )}

      <Row gutter={24}>
        {!disableFields.brandName && (
          <>
            <Col span={12}>
              <ControlledRadio
                required
                control={control}
                name="brandNamePresent"
                label="Is Brand Name Present?"
                errors={errors}
                options={[
                  {
                    value: "Yes",
                    label: "Yes",
                  },
                  {
                    value: "No",
                    label: "No",
                  },
                ]}
                disabled={disabledFormFields}
              />
            </Col>
            {brandNamePresent === "Yes" && (
              <Col span={12}>
                <ControlledTextArea
                  required
                  control={control}
                  name="brandName"
                  label="Brand Name"
                  errors={errors}
                  disabled={disabledFormFields}
                />
              </Col>
            )}
          </>
        )}
      </Row>

      <Row gutter={24}>
        {!disableFields.manufacturingDate && (
          <>
            <Col span={12}>
              <ControlledRadio
                required
                control={control}
                name="manufacturingDatePresent"
                label="Is Manufacturing Date Present on the Pack?"
                errors={errors}
                options={[
                  {
                    value: "Yes",
                    label: "Yes",
                  },
                  {
                    value: "No",
                    label: "No",
                  },
                ]}
                disabled={disabledFormFields}
              />
            </Col>

            {manufacturingDatePresent === "Yes" && (
              <Col span={12}>
                <ControlledDatePicker
                  required
                  control={control}
                  name="manufacturingDate"
                  label="Date of Manufacturing / Packing"
                  errors={errors}
                  maximum={new Date(currentDate.getTime())}
                  disabled={disabledFormFields}
                />
              </Col>
            )}
          </>
        )}
      </Row>

      <Row gutter={24}>
        {!disableFields.expireByDate && (
          <>
            <Col span={12}>
              <ControlledRadio
                required
                control={control}
                name="expireByDatePresent"
                label="Is Expiry Date Present on the Pack?"
                errors={errors}
                options={[
                  {
                    value: "Yes",
                    label: "Yes",
                  },
                  {
                    value: "No",
                    label: "No",
                  },
                ]}
                disabled={disabledFormFields}
              />
            </Col>

            {expireByDatePresent === "Yes" && (
              <Col span={12}>
                <ControlledDatePicker
                  required
                  control={control}
                  name="expireByDate"
                  label="Expiry Date"
                  errors={errors}
                  minimum={new Date(currentDate.getTime())}
                  disabled={disabledFormFields}
                />
              </Col>
            )}
          </>
        )}
      </Row>

      <Row gutter={24}>
        {!disableFields.lotNumber && (
          <>
            <Col span={12}>
              <ControlledRadio
                required
                control={control}
                name="lotNumberPresent"
                label="Is Lot Number Present on the Pack?"
                errors={errors}
                options={[
                  {
                    value: "Yes",
                    label: "Yes",
                  },
                  {
                    value: "No",
                    label: "No",
                  },
                ]}
                disabled={disabledFormFields}
              />
            </Col>

            {lotNumberPresent === "Yes" && (
              <Col span={12}>
                <ControlledInput
                  required
                  control={control}
                  name="lotNumber"
                  label="Lot/Code/Batch No."
                  errors={errors}
                  fullLabelWidth={true}
                  disabled={disabledFormFields}
                />
              </Col>
            )}
          </>
        )}
      </Row>

      <Row gutter={24}>
        {!disableFields.vegSymbolPresent && (
          <Col span={12}>
            <ControlledRadio
              required
              control={control}
              name="vegSymbolPresent"
              label="Is the Veg/Non Veg Logo available on the pack?"
              disabled={options.disableFields.vegSymbolPresent || disabledFormFields}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
              errors={errors}
              fullLabelWidth={true}
            />
          </Col>
        )}
        {!disableFields.vegOrNonVeg && vegSymbolPresent === "Yes" && (
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="vegOrNonVeg"
              label="Veg/Non Veg"
              options={[
                { label: "Veg", value: "Veg" },
                { label: "Non Veg", value: "Non Veg" },
              ]}
              errors={errors}
              fullLabelWidth={true}
              disabled={disabledFormFields}
            />
          </Col>
        )}
      </Row>
      {!disableFields.countryOfOriginPresent && (
        <Row gutter={24}>
          <Col span={12}>
            <ControlledRadio
              required
              control={control}
              name="countryOfOriginPresent"
              label="Is Country of Origin mentioned on the pack"
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
              errors={errors}
              fullLabelWidth={true}
              disabled={disabledFormFields}
            />
          </Col>

          {countryOfOriginPresent === "Yes" && (
            <Col span={12}>
              <ControlledInput
                required
                control={control}
                name="countryOfOrigin"
                label="Country Of Origin"
                errors={errors}
                fullLabelWidth={true}
                disabled={disabledFormFields}
              />
            </Col>
          )}
        </Row>
      )}

      <Row gutter={24}>
        {!disableFields.jaivikKisanLogoPresent && (
          <Col span={12}>
            <ControlledRadio
              required
              control={control}
              name="jaivikKisanLogoPresent"
              label="Is the Jaivik Kisan Logo Present"
              disabled={options.disableFields.jaivikKisanLogoPresent || disabledFormFields}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
              errors={errors}
              fullLabelWidth={true}
            />
          </Col>
        )}
      </Row>
      {!disableFields.manufacturingAddressPresent && (
        <Row gutter={24}>
          <Col span={12}>
            <ControlledRadio
              required
              control={control}
              name="manufacturingAddressPresent"
              label="Does the sample have Manufacturing Address?"
              errors={errors}
              options={[
                {
                  value: "Yes",
                  label: "Yes",
                },
                {
                  value: "No",
                  label: "No",
                },
              ]}
              disabled={disabledFormFields}
            />
          </Col>

          {manufacturingAddressPresent === "Yes" && (
            <Col span={12}>
              <ControlledTextArea
                required
                control={control}
                name="manufacturingAddress"
                label="Manufacturing Address"
                errors={errors}
                disabled={disabledFormFields}
              />
            </Col>
          )}
        </Row>
      )}
    </Form>
  );
};

export default AddLabLabellingForm;
